//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const moment = require("moment-timezone");
import SuccessDialogPushpaymentIM from "@/components/cards/SuccessDialogPushpaymentIM";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";
import pdfvuer from "pdfvuer";

export default {
  name: "AppoinmrntPatentOperation",

  components: {
    SuccessDialog,
    SuccessDialogPush,
    SuccessDialogPushpaymentIM,
    pdf: pdfvuer,
  },
  data() {
    return {
      menuaddAppD: false,
      uploadedFiles: {},
      uploadedFilesDoctype: {},
      dialogCheckbox: false,
      checkboxes: {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      },
      checkboxFields: {
        Form001: "Form 001ก",
        Descriptions: "Descriptions",
        Claims: "Claims",
        Drawings: "Drawings",
        Abstract: "Abstract",
      },
      changeMasterRecord: {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      },
      querydata: {},
      dataappiontment: {},
      isShowPassword: false,
      fullPage: true,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      objecttype_list: [],
      menuReceive: false,
      menuFilling: false,
      menuStart: false,
      menuaddlapd: false,
      menuDeadline: false,
      sourcetypelist: ["Electronic Notice", "Physical Paper Notice", "EMail"],
      statuslist: [
        { status_name: "Pending", status_value: 1 },
        { status_name: "Completed", status_value: 2 },
        { status_name: "Close", status_value: 3 },
      ],
      reportlist: [
        { report_name: "Not Reported", report_value: 0 },
        { report_name: "Reported", report_value: 4 },
        { report_name: "Reported – Pending Invoice", report_value: 1 },
        { report_name: "Invoiced", report_value: 2 },
        { report_name: "Reported & Invoiced", report_value: 3 },
      ],
      category_ptlist: [
        "New Application",
        "Office Action",
        "Publication Fee",
        "Publication",
        "Substantive Examination",
        "Publication Fee & Registration Fee",
        "Publication Fee & Registration Fee & Annuity Fee",
        "Registration Fee",
        "Registration Fee & Annuity Fee",
        "Certificate",
        "Annuity Fee",
      ],
      doctype_actions_select: [],
      doctype_actions_tlist: [],
      typelist: [
        { type_name: "Design", type_number: "1" },
        { type_name: "Invention", type_number: "2" },
        { type_name: "Petty", type_number: "3" },
        { type_name: "Invention/PCT", type_number: "4" },
      ],
      documenttype_ptlist: [],
      documenttype_ptlist_search: [],
      app_noshow: "",
      typeshow: 0,
      titleshow: "",
      receive_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      filling_date: null,
      startdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      enddate: null,
      internaldate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      associate_contact_name: "",
      agent_contact_name: "",
      date_of_application: null,
      itemdata: {
        new_filling: null,
        date_of_application: null,
        last_annuity_paid: null,
        owner_contact: "",
        associate_contact: 0,
        agent_contact: 0,
        next_annuity_date: null,
        final_due_date_for_next_payment: null,
        dead_last_annuity_paid: "",
        objecttype: 0,
        doctype: 0,
        trademark_name: "",
        refno: "",
        categories: "",
        filling_date: null,
        receive_date: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        startdate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        enddate: null,
        internaldate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        sourcetype: "",
        app_no: "",
        description: "",
        remark: "",
        report: 0,
        paymentrequest: false,
        cert: false,
        nextdeadlineninety: false,
        nextdeadlinesixty: false,
        done: false,
        closed: 1,
      },
      getpreview_listnotice: [],
      preview_listnotice: [],
      image_listnotice: [],
      filenamenotice: [],
      preview_listnotice2: [],
      preview_listattach: [],
      preview_listrecicpt: [],
      image_listattach: [],
      image_listrecicpt: [],
      filenameattach: [],
      filenamerecive: [],
      getpreview_listattach: [],
      getpreview_listreceipt: [],
      preview_listattach2: [],
      preview_listrecipt2: [],
      previewpopupfile: [],
      previewpopupfile2: [],
      checkfileapreview: false,
      dialogpreviewfilenotice: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      numPagespreviewattach: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      previewattachimage: "",
      dialogpreviewattachimage: false,
      dialogconfirmdeletenoticefile: false,
      dialogconfirmdeleteattachfile: false,
      dialogconfirmdeleteattrecipt: false,
      indexdeleteattachfile: -1,
      indexdeleteattreciept: -1,
      indexdeleteattachfilelist: -1,
      customer_id_forpatmentrequest: 0,
      showAnn: false,
      showAnnReg: false,
      showAnnfirst: false,
      showNew: false,
      showChage: false,
      showSub: false,
      latest_list: [
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
      ],
      menuaddnewfilling: false,
      menuaddnad: false,
      menuaddnadfinalDatePayment: false,
      new_filling: false,
      data_maserter_pt: [],
      data_maserter_pt_priority: [],
      default_col: true,
      default_type: true,
      last_annuity_paid: null,
      next_annuity_date: null,
      final_due_date_for_next_payment: null,
      contact_agent_list: [],
      contact_associate_list: [],
      contact_owner_list: [],
      showNewFilingExact: false,
      showNewFilingSubdoc: false,
    };
  },
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();

    await this.loaddataobjecttypeBygroupId();
    await this.loaddatadocumentPTtype();

    // let map_data = await api.mapKeyWordPT(this.app_noshow, this.itemdata.refno);
    // this.itemdata.doctype = map_data.data.doctype_id;

    if (this.app_noshow !== "" && this.itemdata.refno !== "") {
      // --------------- check data in ocr table ----------------
      let ocr_data = await api.checkAppointmentOCR(
        this.app_noshow,
        this.itemdata.refno
      );

      if (ocr_data.data !== null) {
        let map_data = await api.mapKeyWordPT(
          this.app_noshow,
          this.itemdata.refno
        );
        this.itemdata.doctype = map_data.data.doctype_id;
      } else {
      }

      // --------------- check data in map table ----------------
    }
    await this.loadDataDotypeAction();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loaddatafile_no();

    this.prev_doctype_actions_select = [...this.doctype_actions_select];
    this.$hideLoader();
  },
  methods: {
    async onAppNoBlur() {
      var check_appno = await api.getAppNpCheck({
        params: {
          id: this.data_maserter_pt.masterpt_id,
          app_no: this.itemdata.app_no,
        },
      });
      if (check_appno.status == 203) {
        this.itemdata.app_no = this.data_maserter_pt.app_no;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "data duplicate ",
          "please check Application No.",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    updateFinalDueDateFromNextAnnuity() {
      var dateString = this.next_annuity_date;

      if (!dateString) return "";

      const [year, month, day] = dateString.split("-").map(Number);
      const date = new Date(year, month - 1, day); // สร้าง Date

      if (this.showAnnfirst) {
        date.setDate(date.getDate() + 59); // บวก 60 วัน
      } else {
        date.setDate(date.getDate() + 60);
      }

      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");

      this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
    },
    chageobjecttype() {
      if (this.itemdata.objecttype != 0) {
        const matchedDoc = this.documenttype_ptlist.filter(
          (item) => item.objecttype_id == this.itemdata.objecttype
        );

        this.documenttype_ptlist_search = matchedDoc;
        const exists = this.documenttype_ptlist_search.some(
          (item) => item.documenttype_id === this.itemdata.doctype
        );
        if (!exists) {
          this.itemdata.doctype = 0;
        }
      }
    },
    calDateAnn() {
      this.itemdata.next_annuity_date = this.formatDate(
        this.data_maserter_pt.next_annuity_date_pt
      );

      const cal_y =
        Number(this.itemdata.dead_last_annuity_paid) -
        Number(this.data_maserter_pt.dead_last_annuity_paid_pt);

      if (cal_y !== 0) {
        // แปลง next_annuity_date จาก dd/mm/yyyy → Date
        const [day, month, year] = this.itemdata.next_annuity_date
          .split("/")
          .map(Number);
        const nextDate = new Date(year, month - 1, day);

        // เพิ่ม/ลดปีตาม cal_y
        nextDate.setFullYear(nextDate.getFullYear() + cal_y);

        // กำหนดค่ากลับให้ next_annuity_date
        const updatedNextDate = `${nextDate.getFullYear()}-${String(
          nextDate.getMonth() + 1
        ).padStart(2, "0")}-${String(nextDate.getDate()).padStart(2, "0")}`;
        this.itemdata.next_annuity_date = this.formatDate(updatedNextDate);

        // คำนวณ final_due_date โดยบวก 60 วัน
        const finalDue = new Date(nextDate);

        if (this.showAnnfirst) {
          finalDue.setDate(finalDue.getDate() + 59);
        } else {
          finalDue.setDate(finalDue.getDate() + 60);
        }

        const d = String(finalDue.getDate()).padStart(2, "0");
        const m = String(finalDue.getMonth() + 1).padStart(2, "0");
        const y = finalDue.getFullYear();

        this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
      } else {
        // ไม่ต้องคำนวณใหม่ ใช้ค่าจาก master
        this.itemdata.next_annuity_date = this.formatDate(
          this.data_maserter_pt.next_annuity_date_pt
        );
        this.itemdata.final_due_date_for_next_payment = this.formatDate(
          this.data_maserter_pt.final_due_date_for_next_payment_pt
        );
      }

      this.$forceUpdate();
    },
    fileDoctypeInput() {
      // หาว่า id ไหนถูกลบออก
      const removed = this.prev_doctype_actions_select.filter(
        (id) => !this.doctype_actions_select.includes(id)
      );

      // ลบไฟล์ที่เกี่ยวข้อง
      removed.forEach((id) => {
        this.$delete(this.uploadedFilesDoctype, id);
      });

      // อัปเดตค่าก่อนหน้า
      this.prev_doctype_actions_select = [...this.doctype_actions_select];
    },
    async loadDataDotypeAction() {
      const res_doctye_actions = await api.getbyobjectgroup_id(2);
      this.doctype_actions_tlist = res_doctye_actions.data;
    },
    triggerFileInput(key) {
      this.$refs[`fileInput_${key}`][0].click();
    },
    handleFileUpload(event, key) {
      const files = Array.from(event.target.files);

      // เก็บชื่อไฟล์ทั้งหมดที่มีอยู่ใน uploadedFiles ทุก key
      const allUploadedNames = Object.values(this.uploadedFiles)
        .flat()
        .map((f) => f.name);

      if (!this.uploadedFiles[key]) {
        this.$set(this.uploadedFiles, key, []);
      }

      files.forEach((file) => {
        let newName = file.name;
        let baseName = newName;
        let ext = "";

        // แยกนามสกุลไฟล์ (.docx, .doc ฯลฯ)
        const dotIndex = newName.lastIndexOf(".");
        if (dotIndex !== -1) {
          baseName = newName.substring(0, dotIndex);
          ext = newName.substring(dotIndex);
        }

        let counter = 1;
        // ตรวจสอบว่าชื่อไฟล์ซ้ำไหมใน allUploadedNames
        while (allUploadedNames.includes(newName)) {
          newName = `${baseName}-${counter}${ext}`;
          counter++;
        }

        // สร้างไฟล์ใหม่ clone พร้อมชื่อใหม่
        const renamedFile = new File([file], newName, { type: file.type });

        // เพิ่มชื่อใหม่เข้า allUploadedNames เพื่อกันชื่อซ้ำกับไฟล์ถัดไป
        allUploadedNames.push(newName);

        // เพิ่มไฟล์ลงใน uploadedFiles
        this.uploadedFiles[key].push(renamedFile);
      });
    },
    removeFile(key, index) {
      this.uploadedFiles[key].splice(index, 1); // ลบไฟล์ตาม index
    },
    triggerFileInputDoctype(itemId) {
      this.$refs[`fileInput_${itemId}`][0].click();
    },
    handleFileUploadDoctype(event, itemId) {
      const file = event.target.files[0];
      if (file) {
        this.$set(this.uploadedFilesDoctype, itemId, file);
      }
    },
    cancelCheckbox() {
      this.dialogCheckbox = false;
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
      this.uploadedFiles = {};
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
    },
    saveSelection() {
      this.dialogCheckbox = false;
    },
    openselectFileWorld() {
      this.dialogCheckbox = true;
    },
    async previewMultiFile(event) {
      this.getpreview_listnotice = [];
      this.preview_listnotice = [];
      var getdataname = [];
      // this.image_listnotice = [];
      // this.filenamenotice = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listnotice.push(e.target.result);
            this.preview_listnotice.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listnotice.push(input.files[index]);
            getdataname.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      // await this.getPdf(this.getpreview_listnotice, "newfile");
      this.preview_listnotice2 = this.preview_listnotice;
      getdataname.forEach((x) => {
        this.filenamenotice.push(x.name);
      });
      this.checkfilenotice = true;
    },
    async previewnoticefilepdf(index) {
      var checkfile = this.image_listnotice[index];

      if (checkfile.type == `application/pdf`) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result;
          let pdf_newTab = window.open("");
          pdf_newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${checkfile}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
          pdf_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result; // Base64 image data
          let image_newTab = window.open(""); // เปิดแท็บใหม่
          image_newTab.document.write(`
            <html>
              <head>
                <title>Image Preview</title>
                <style>
                  html, body {
                    margin: 50px 0 0 0;
                    height: 80%;
                    overflow: hidden;
                    background-color: black;
                    display: flex;
                    justify-content: center; /* จัดกลางในแนวนอน */
                    align-items: center; /* จัดกลางในแนวตั้ง */
                  }
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain; /* รูปภาพจะไม่ยืดออก */
                  }
                </style>
              </head>
              <body>
                <img src="${checkfile}" title="Image Preview" />
              </body>
            </html>
          `);
          image_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }
    },
    async closepreviewfile() {
      this.dialogpreviewfilenotice = false;
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },
    async confirmdeletenoticefile(index) {
      this.indexdeleteattachfilelist = index;
      this.dialogconfirmdeletenoticefile = true;
    },
    async closedialogconfirmdeletenoticefile() {
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeletenoticefile() {
      this.getpreview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.preview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.image_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.filenamenotice.splice(this.indexdeleteattachfilelist, 1);
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeletereceipt() {
      this.filenamerecive.splice(this.indexdeleteattreciept, 1);
      this.getpreview_listreceipt.splice(this.indexdeleteattreciept, 1);
      this.preview_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.image_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.dialogconfirmdeleteattrecipt = false;
    },
    async previewMultiAttachFile() {
      // this.preview_listattach = [];
      // this.image_listattach = [];
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listattach.push(e.target.result);
            this.preview_listattach.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listattach.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      // await this.getPdf(this.getpreview_listattach, "newfile");
      this.preview_listattach2 = this.preview_listattach;
      this.image_listattach.forEach((x) => {
        this.filenameattach.push(x.name);
      });
      this.checkfileattach = true;
    },
    async previewMultiReceipt() {
      // this.preview_listattach = [];
      // this.image_listattach = [];
      this.filenamerecive = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listreceipt.push(e.target.result);
            this.preview_listrecicpt.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listrecicpt.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }

      // await this.getPdf(this.getpreview_listattach, "newfile");
      this.preview_listrecipt2 = this.preview_listrecicpt;
      this.image_listrecicpt.forEach((x) => {
        this.filenamerecive.push(x.name);
      });
      this.checkfileattach = true;
    },
    async previewattachfile(index) {
      if (this.filenameattach[index].split(/[\s.]+/).pop() == "pdf") {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `
          <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${this.getpreview_listattach[index]}" title="PDF Preview"></iframe>
              </body>
            </html>
            `
        );

        return;
      } else {
        this.previewattachimage = this.getpreview_listattach[index];
        // this.dialogpreviewattachimage = true;
        const imageTab = window.open("");
        imageTab.document.write(`
          <html>
            <head>
              <title>Preview Image</title>
            </head>
            <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
              <img src="${this.previewattachimage}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            </body>
          </html>
        `);
        return;
      }
    },
    async previewreceiptfile(index) {
      if (this.filenamerecive[index].split(/[\s.]+/).pop() == "pdf") {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `
          <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${this.getpreview_listreceipt[index]}" title="PDF Preview"></iframe>
              </body>
            </html>
            `
        );

        return;
      } else {
        this.previewreceipt = this.getpreview_listreceipt[index];
        // this.dialogpreviewattachimage = true;
        const imageTab = window.open("");
        imageTab.document.write(`
          <html>
            <head>
              <title>Preview Image</title>
            </head>
            <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
              <img src="${this.previewreceipt}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            </body>
          </html>
        `);
        return;
      }
    },
    async getPforpreviewattach(datafile) {
      this.previewpopupattachfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupattachfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreviewattach = pdf.numPages;
        });
      });
    },
    async closepreviewattachfile() {
      this.dialogpreviewattachfile = false;
    },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async confirmdeleteattreceipt(index) {
      this.indexdeleteattreciept = index;
      this.dialogconfirmdeleteattrecipt = true;
    },
    async closepreviewreceipt(index) {
      this.indexdeleteattreciept = -1;
      this.dialogconfirmdeleteattrecipt = false;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },

    async loaddatafile_no() {
      if (this.$route.params.file_no) {
        this.itemdata.refno = this.$route.params.file_no;
        this.onSearchfile_no(this.itemdata.refno);
      }
    },
    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(2);
      this.objecttype_list = result.data;
    },
    async loaddatadocumentPTtype() {
      const result = await api.getdocumenttype_ptcode();
      this.documenttype_ptlist = result.data;
      this.documenttype_ptlist_search = result.data;
    },
    async onSearchfile_no(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      this.$showLoader()
      this.itemdata.refno = this.itemdata.refno.trim().toUpperCase();
      const result = await api.getfile_noPT(file_no);
      console.log(result.data)
      if (result.data[0]) {
        this.data_maserter_pt = result.data[0];

        const res_priority = await api.getAllMASTERPT_PRIORITY_BYID(
          Number(result.data[0].masterpt_id)
        );
        this.data_maserter_pt_priority = res_priority.data;

        this.titleshow = result.data[0].title;
        this.itemdata.objecttype = result.data[0].tm_type;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        // this.customer_id_forpatmentrequest =
        //   result.data[0].agent_contact_custid != 0
        //     ? result.data[0].agent_contact_custid
        //     : result.data[0].owner_contact_custid != 0
        //     ? result.data[0].owner_contact_custid
        //     : 0;

        // if (
        //   result.data[0].owner_contact_id &&
        //   result.data[0].owner_contact_id != ""
        // ) {
        //   this.itemdata.owner_contact = result.data[0].owner_contact_id;
        //   var ownername = result.data[0].owner_contact_id;
        //   var listid_owner = ownername.split(",").map((s) => Number(s.trim()));
        //   const matchedContactsOwner = this.contact_owner_list.filter(
        //     (contact) => listid_owner.includes(contact.contact_id)
        //   );
        //   this.itemdata.trademark_name = "";
        //   this.itemdata.trademark_name = matchedContactsOwner
        //     .map((c) => c.contact_name)
        //     .join(", ");
        // } else {
        //   this.itemdata.trademark_name = "";
        // }
        if (
          result.data[0].agent_contact_id &&
          result.data[0].agent_contact_id != 0
        ) {
          this.itemdata.agent_contact = result.data[0].agent_contact_id;

          this.contact_agent_list.filter((item) => {
            if (Number(item.contact_id) == Number(this.itemdata.agent_contact)) {
              this.agent_contact_name = item.contact_name;
            }
          });
        } else {
          this.agent_contact_name = "";
        }

        if (
          result.data[0].associate_contact_id &&
          result.data[0].associate_contact_id != 0
        ) {
          this.itemdata.associate_contact = result.data[0].associate_contact_id;
          this.contact_associate_list.filter((item) => {
            if (Number(item.contact_id) == Number(this.itemdata.associate_contact)) {
              this.associate_contact_name = item.contact_name;
            }
          });
        } else {
          this.associate_contact_name = "";
        }
        //   // else{
        //   //   this.agent_contact_name = ""
        //   // }
        this.$hideLoader()
        this.checktypeFunction();
      } else {
        this.$hideLoader()
        this.data_maserter_pt = [];
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        // this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async onSearchfile_nosave(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      //alert(file_no);
      const result = await api.getfile_noPT(file_no);

      if (result.data[0]) {
        //alert("hevedata");
        this.titleshow = result.data[0].title;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        // this.customer_id_forpatmentrequest =
        //   result.data[0].agent_contact_custid != 0
        //     ? result.data[0].agent_contact_custid
        //     : result.data[0].owner_contact_custid != 0
        //       ? result.data[0].owner_contact_custid
        //       : 0;
      } else {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        // this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    checktypeFunction() {
      if (this.itemdata.doctype == 0) return;

      const doctype = this.documenttype_ptlist.find(
        (item) => item.documenttype_id === this.itemdata.doctype
      );
      if (!doctype) return;

      const code = doctype.documenttype_code;

      const isAnnuity = code.includes("Annuity Fees");
      const isRegistration = code === "Registration & Annuity Fees";

      const isNewFiling = code.includes("New Filing");
      const isNewFilingExact = code === "New Filing";
      const isNewFilingSubDoc = code === "New Filing Sub Doc";

      const isChangeMaster = code.includes("Change Master of Record");
      const isSubstantiveExam = code.includes("Substantive Examination");

      // Default: reset flags
      this.default_col = !isAnnuity && !isNewFiling && !isChangeMaster;
      this.showAnn = false;
      this.showAnnReg = false;
      this.showAnnfirst = false;
      this.showNew = false;
      this.showNewFilingExact = false;
      this.showNewFilingSubdoc = false;
      this.showChage = false;
      this.showSub = false;

      // Clear fields
      this.itemdata.dead_last_annuity_paid = "";
      this.itemdata.last_annuity_paid = null;
      this.itemdata.next_annuity_date = null;
      this.itemdata.new_filling = null;
      this.itemdata.date_of_application = null;
      this.itemdata.receive_date = this.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      );
      this.receive_date = this.changeformatDatetoinsert(
        this.itemdata.receive_date
      );

      this.changeMasterRecord = {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      };

      if (isAnnuity) {
        this.default_col = false;
        this.showAnn = true;
        if (this.data_maserter_pt) {
          this.itemdata.dead_last_annuity_paid =
            this.data_maserter_pt.dead_last_annuity_paid_pt;
          this.itemdata.last_annuity_paid = this.formatDate(
            this.data_maserter_pt.last_annuity_paid_pt
          );
          this.itemdata.next_annuity_date = this.formatDate(
            this.data_maserter_pt.next_annuity_date_pt
          );
          this.itemdata.final_due_date_for_next_payment = this.formatDate(
            this.data_maserter_pt.final_due_date_for_next_payment_pt
          );
        }
        if (isRegistration) {
          this.showAnnReg = true;
          this.default_col = true;
        } else {
          this.showAnnfirst = true;
        }
      }

      if (isNewFiling) {
        this.itemdata.enddate = null;
        this.showNew = true;
        this.default_col = false;

        const sorted = [...this.data_maserter_pt_priority].sort(
          (a, b) => new Date(a.priority_date) - new Date(b.priority_date)
        );
        const oldest = sorted[0]?.priority_date;
        if (oldest !== undefined && oldest) {
          const [y, m, d] = oldest.split("-").map(Number);
          const date = new Date(y, m - 1, d);

          if (this.data_maserter_pt.sub_type === "PARIS")
            date.setMonth(date.getMonth() + 12);
          if (this.data_maserter_pt.sub_type === "PCT")
            date.setMonth(date.getMonth() + 30);

          this.itemdata.new_filling = `${String(date.getDate()).padStart(
            2,
            "0"
          )}/${String(date.getMonth() + 1).padStart(
            2,
            "0"
          )}/${date.getFullYear()}`;
        }
        if (isNewFilingExact) {
          this.showNewFilingExact = true;
          this.itemdata.date_of_application = this.formatDate(
            this.data_maserter_pt.date_of_application
          );
          this.itemdata.app_no = this.data_maserter_pt.app_no;
          this.date_of_application = this.data_maserter_pt.date_of_application;
        } else if (isNewFilingSubDoc) {
          this.showNewFilingSubdoc = true;
          this.default_col = true;
          if (this.data_maserter_pt.date_of_application) {
            this.itemdata.receive_date = this.formatDate(
              this.data_maserter_pt.date_of_application
            );
            this.receive_date = this.changeformatDatetoinsert(
              this.itemdata.receive_date
            );
            this.calDateFinalDeadline();
          } else {
            this.itemdata.receive_date = null;
          }
        }
      }

      if (isChangeMaster) {
        this.showChage = true;
        this.default_col = false;
        this.default_type = false; // ✅ ตั้งค่า default_type ที่นี่เท่านั้น
      } else {
        this.default_type = true; // ✅ ถ้าไม่ใช่ Change Master ให้เป็น true
      }

      // No need to do anything for isSubstantiveExam – fields already cleared
      if (isSubstantiveExam) {
        this.showSub = true;
        if (this.data_maserter_pt.date_of_application) {
          this.itemdata.receive_date = this.formatDate(
            this.data_maserter_pt.date_of_publishing
          );
          this.receive_date = this.data_maserter_pt.date_of_publishing;

          this.itemdata.enddate = this.formatDate(
            this.data_maserter_pt.exam_request_deadline
          );
          this.enddate = this.data_maserter_pt.exam_request_deadline;

          this.enddate = this.data_maserter_pt.exam_request_deadline;

          if (this.enddate) {
            let d = new Date(this.enddate); // แปลง string → Date
            d.setDate(d.getDate() + 60); // บวก 60 วัน
            this.itemdata.internaldate = this.formatDate(
              d.toISOString().split("T")[0]
            ); // คืนค่าเป็น YYYY-MM-DD
            this.internaldate = d.toISOString().split("T")[0]; // คืนค่าเป็น YYYY-MM-DD
          } else {
            this.itemdata.internaldate = null;
          }

          // this.calDateFinalDeadline()
        } else {
          this.itemdata.receive_date = null;
        }
        // this.itemdata.receive_date = null;
        // this.itemdata.enddate = null;
        // this.itemdata.internaldate = null;
      } else {
        if (!isNewFiling && !isSubstantiveExam) {
          this.itemdata.receive_date = this.formatDate(
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substr(0, 10)
          );
          this.calDateFinalDeadline();
        }
      }
      this.$forceUpdate();
    },
    calDateFinalDeadline() {
      if (this.itemdata.doctype != 0 && this.itemdata.doctype) {
        console.log(this.itemdata.receive_date);
        console.log(this.receive_date);
        if (this.showSub) {
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);
          date.setFullYear(date.getFullYear() + 5);
          date.setDate(date.getDate() - 1);

          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0");
          const d = String(date.getDate()).padStart(2, "0");
          this.itemdata.enddate = `${d}/${m}/${y}`;

          const internalDate = new Date(date);
          const originalDay = internalDate.getDate();
          internalDate.setMonth(internalDate.getMonth() - 6);
          if (internalDate.getDate() < originalDay) {
            internalDate.setDate(0);
          }

          const iy = internalDate.getFullYear();
          const im = String(internalDate.getMonth() + 1).padStart(2, "0");
          const id = String(internalDate.getDate()).padStart(2, "0");
          this.itemdata.internaldate = `${id}/${im}/${iy}`;
        } else {
          const dataItem = this.documenttype_ptlist.find(
            (item) => item.documenttype_id === this.itemdata.doctype
          );

          const dateplus = dataItem?.numberofenddate
            ? dataItem.numberofenddate - 1
            : 0;

          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);
          date.setDate(date.getDate() + dateplus);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          this.itemdata.enddate = `${dd}/${mm}/${yyyy}`;

          const internalDate = new Date(date);
          internalDate.setDate(internalDate.getDate() - 7);

          const idd = String(internalDate.getDate()).padStart(2, "0");
          const imm = String(internalDate.getMonth() + 1).padStart(2, "0");
          const iyyyy = internalDate.getFullYear();
          this.itemdata.internaldate = `${idd}/${imm}/${iyyyy}`;
        }
      }
    },

    async saveItem(mode) {
      var dataset = [];
      // this.onSearchfile_nosave(this.itemdata.refno);

      if (this.itemdata.objecttype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Object Type ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.doctype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put PF Work Type ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.refno == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put File NO ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (mode == "paymentrequest") {
        const checkMaterPT = await api.getfile_noPTPayment(this.itemdata.refno);
        console.log(checkMaterPT.data)
        if (checkMaterPT.data.length > 0) {
          dataset = checkMaterPT.data[0];

          if (!dataset.cus_billing_id || dataset.cus_billing_id == "") {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data ",
              "Please verify the customer's billing details.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
      }
      // if (this.doctype_actions_select.length == 0) {
      //   this.$store.state.global_dialog = true;
      //   this.setupAlertDialog(
      //     true,
      //     "Check data ",
      //     "Put Doc Type",
      //     "text-h5 red--text text-center"
      //   );
      //   return;
      // }

      if (this.showSub) {
        if (!this.itemdata.receive_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Sub Exam Request Deadline Date",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (!this.itemdata.enddate) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Fixed Internal Date",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.itemdata.internaldate) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Publication Date",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      const checkfile_noPT = await api.getfile_noPT(this.itemdata.refno);

      if (checkfile_noPT.data[0]) {
        let formData = new FormData();

        //Upload Notice File
        if (this.image_listnotice.length > 0) {
          this.image_listnotice.forEach((x, index) => {
            formData.append(`file`, x);
          });
        }

        if (this.image_listnotice.length > 0) {
          let getnamefilenameattach = "";
          this.filenamenotice.forEach((x, index) => {
            if (index > 0) {
              getnamefilenameattach += `,${x}`;
            } else {
              getnamefilenameattach += `${x}`;
            }
          });
          formData.append(
            `notice_file`,
            getnamefilenameattach.replace(/\s/g, "_")
          );
        }

        //Upload Submitted File(s
        if (this.image_listattach.length > 0) {
          this.image_listattach.forEach((x, index) => {
            formData.append(`file`, x);
          });
        }

        if (this.image_listattach.length > 0) {
          let getnamefilenameattach = "";
          this.filenameattach.forEach((x, index) => {
            if (index > 0) {
              getnamefilenameattach += `,${x}`;
            } else {
              getnamefilenameattach += `${x}`;
            }
          });
          formData.append(
            `attachment_files`,
            getnamefilenameattach.replace(/\s/g, "_")
          );
        }

        //Upload Receipt(s)
        if (this.image_listrecicpt && this.image_listrecicpt.length > 0) {

          this.image_listrecicpt.forEach((file) => {
            formData.append("file", file);
          });

          const safeFileNames = this.image_listrecicpt.map((file) => {
            return file.name
              .trim()
              .replace(/\s+/g, "_")
              .replace(/,+/g, "")
              .replace(/[^\w.-]/g, "");
          });

          const fileNameString = safeFileNames.join(",");

          formData.append("receipt_files", fileNameString);
        }

        // Upload Soft File(s)
        // if (
        //   this.uploadedFiles &&
        //   typeof this.uploadedFiles === 'object' &&
        //   Object.keys(this.uploadedFiles).length > 0
        // ) {
        //   for (const [key, value] of Object.entries(this.uploadedFiles)) {
        //     formData.append(`file`, value);
        //     formData.append(`${key}`, value.name);
        //   }

        // }

        formData.append("objecttype", this.itemdata.objecttype);
        formData.append("doctype", this.itemdata.doctype);

        formData.append("cert", this.itemdata.cert);
        formData.append("report", this.itemdata.report);
        formData.append("done", this.itemdata.done);
        formData.append("closed", this.itemdata.closed);

        formData.append("nextdeadlineninety", 0);
        formData.append("nextdeadlinesixty", 0);
        if (mode == "paymentrequest") {
          this.itemdata.paymentrequest = 1;
        }
        formData.append("paymentrequest", this.itemdata.paymentrequest);

        formData.append("sourcetype", this.itemdata.sourcetype);
        formData.append("trademark_name", ``);
        formData.append("owner_name", this.itemdata.trademark_name);
        formData.append(`refno`, this.itemdata.refno.trim());
        formData.append(`categories`, this.itemdata.categories.trim());
        formData.append(`description`, this.itemdata.description.trim());
        formData.append(`remark`, this.itemdata.remark);

        formData.append(
          `create_by`,
          Number(localStorage.getItem(server.USER_ID))
        );

        formData.append(`owner_contact`, this.itemdata.owner_contact);
        formData.append(`agent_contact`, this.itemdata.agent_contact);
        formData.append(`associate_contact`, this.itemdata.associate_contact);

        formData.append(
          `filling_date`,
          this.changeformatDatetoinsert(this.itemdata.filling_date)
        );
        formData.append(
          `receive_date`,
          this.changeformatDatetoinsert(this.itemdata.receive_date)
        );
        formData.append(
          `startdate`,
          this.changeformatDatetoinsert(this.itemdata.startdate)
        );
        formData.append(
          `enddate`,
          this.changeformatDatetoinsert(this.itemdata.enddate)
        );
        formData.append(
          `internaldate`,
          this.changeformatDatetoinsert(this.itemdata.internaldate)
        );
        if (this.showSub) {
          formData.append("check_sub", true);
        } else {
          formData.append("check_sub", false);
        }
        if (this.showAnn) {
          formData.append(
            "dead_last_annuity_paid",
            this.itemdata.dead_last_annuity_paid || ""
          );
          formData.append(
            "last_annuity_paid",
            this.changeformatDatetoinsert(this.itemdata.last_annuity_paid) || ""
          );
          formData.append(
            "next_annuity_date",
            this.changeformatDatetoinsert(this.itemdata.next_annuity_date) || ""
          );
          formData.append(
            "final_due_date_for_next_payment",
            this.changeformatDatetoinsert(
              this.itemdata.final_due_date_for_next_payment
            ) || ""
          );
          formData.append("check_doc", true);

          if (this.showAnnReg) {
            formData.set(
              `filling_date`,
              this.changeformatDatetoinsert(this.itemdata.filling_date)
            );
            formData.set(
              `receive_date`,
              this.changeformatDatetoinsert(this.itemdata.receive_date)
            );
            formData.set(
              `startdate`,
              this.changeformatDatetoinsert(this.itemdata.startdate)
            );
            formData.set(
              `enddate`,
              this.changeformatDatetoinsert(this.itemdata.enddate)
            );
            formData.set(
              `internaldate`,
              this.changeformatDatetoinsert(this.itemdata.internaldate)
            );
          } else {
            formData.set("filling_date", null);
            formData.set("receive_date", null);
            formData.set("startdate", null);
            formData.set(
              "enddate",
              this.changeformatDatetoinsert(this.itemdata.next_annuity_date) ||
              null
            );
            formData.set("internaldate", null);
          }
        } else {
          formData.append("dead_last_annuity_paid", "");
          formData.append("last_annuity_paid", "");
          formData.append("next_annuity_date", "");
          formData.append("final_due_date_for_next_payment", "");
          formData.append("check_doc", false);
        }

        if (this.showNew) {
          formData.append(
            "new_filling",
            this.changeformatDatetoinsert(this.itemdata.new_filling) || ""
          );

          formData.set("filling_date", null);
          formData.set("receive_date", null);
          formData.set("startdate", null);
          if (this.showNewFilingExact) {
            formData.set("newfilingECheck", true);
            formData.set("app_no", this.itemdata.app_no);
            formData.set(
              "date_of_application",
              this.changeformatDatetoinsert(
                this.itemdata.date_of_application
              ) || null
            );
            formData.set(
              "enddate",
              this.changeformatDatetoinsert(this.itemdata.enddate) || null
            );
          } else {
            formData.set("date_of_application", null);
            formData.set("newfilingECheck", false);
            formData.set("app_no", "");

            formData.set(
              "filling_date",
              this.changeformatDatetoinsert(this.itemdata.filling_date) || null
            );
            formData.set(
              "receive_date",
              this.changeformatDatetoinsert(this.itemdata.receive_date) || null
            );
            formData.set(
              "startdate",
              this.changeformatDatetoinsert(this.itemdata.startdate) || null
            );
          }
        } else {
          formData.set("newfilingECheck", false);
          formData.set("app_no", "");
          formData.set("date_of_application", null);
        }

        // if(this.doctype_actions_select.length > 0){
        //   const doclist_select = this.doctype_actions_select.join(", ");
        //   formData.append("documenttype_action_id", doclist_select);
        // }else{
        //   formData.append("documenttype_action_id", "");
        // }

        formData.append("documenttype_action_id", "");
        this.$showLoader();
        const resultAppointment = await api.AppointmentAddV2(formData);

        if (
          resultAppointment.status == 200 ||
          resultAppointment.status == 201
        ) {
          if (this.doctype_actions_select.length > 0) {
            for (const [index, item] of this.doctype_actions_select.entries()) {
              var dataAdd = {
                documenttype_action_id: item,
                appointment_id: resultAppointment.data.appointment_id,
                appointment_type: `Patent`,
                documenttype_follow: 0,
              };
              await api.createAppointmentDoctypeActions(dataAdd);
            }
          }
          let formDataSoft = new FormData();

          if (this.uploadedFiles && typeof this.uploadedFiles === "object") {
            for (const [key, files] of Object.entries(this.uploadedFiles)) {
              if (Array.isArray(files)) {
                // เพิ่มไฟล์
                files.forEach((file) => {
                  formDataSoft.append("file", file);
                });
                // เก็บชื่อไฟล์คั่นด้วย ,
                const fileNames = files.map((file) => file.name).join(",");
                formDataSoft.append(key, fileNames);
              } else {
                formDataSoft.append("file", files);
                formDataSoft.append(key, files.name);
              }
            }
          }

          await api.createSotfFile(
            resultAppointment.data.appointment_id,
            formDataSoft
          );

          var dataaddchangeMasterRecord = this.changeMasterRecord;
          dataaddchangeMasterRecord.appointment_id =
            resultAppointment.data.appointment_id;
          dataaddchangeMasterRecord.create_by = Number(
            localStorage.getItem(server.USER_ID)
          );
          await api.createCHAGE_MASTER_RECORD(dataaddchangeMasterRecord);

          var dataAdd = {
            user_id: localStorage.getItem(server.USER_ID),
            log_in_out_id: localStorage.getItem(server.LOGIN_ID),
            action: "Create",
            table_name: "appointment",
            table_id: resultAppointment.data.appointment_id,
            date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          };

          await api.addTransectionLog(dataAdd);

          var dataEditLog = {
            last_update: moment()
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD HH:mm:ss"),
          };
          await api.updateLogInOutLog(
            localStorage.getItem(server.LOGIN_ID),
            dataEditLog
          );
          this.$hideLoader();

          if (mode == "paymentrequest") {
            var dataPush = {
              customer_name_master: dataset.cus_name,
              yourRef: "",
              ourRef: "",
              docketId: resultAppointment.data.appointment_id,
            };

            var custonerId = 0;
            custonerId = Number(dataset.cus_billing_id);
            const hasThai = /[\u0E00-\u0E7F]/;

            if (hasThai.test(dataset.cus_name)) {
              dataPush.yourRef = `เลขที่อ้างอิงของลูกค้า: ${dataset.client_ref}`;
              dataPush.ourRef = `เลขที่อ้างอิงของบริษัท: ${dataset.file_no}`;
            } else {
              dataPush.yourRef = `Your Ref: ${dataset.client_ref}`;
              dataPush.ourRef = `Our Ref: ${dataset.file_no}`;
            }
            if (dataset.client_ref.trim() == "") {
              dataPush.yourRef = "";
            }
            this.$router.push({
              path: `/new-free-invoice/0/invoice/D/${custonerId}/Docket`,
              query: dataPush,
            });
            return;
          } else {
            this.$hideLoader();
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              "/appointment-patent-list"
            );
            return;
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "save data",
            "can't save data",
            "text-h5 red--text text-center"
          );
          return;
        }
      } else {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },

    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async setupAlertDialogPushpaymentIM(
      status,
      title,
      message,
      text_color,
      link,
      querydata
    ) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
      this.querydata = querydata;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
  watch: {
    date_of_application(val) {
      this.itemdata.date_of_application = this.formatDate(
        this.date_of_application
      );
    },
    receive_date(val) {
      this.itemdata.receive_date = this.formatDate(this.receive_date);
    },
    filling_date(val) {
      this.itemdata.filling_date = this.formatDate(this.filling_date);
    },
    startdate(val) {
      this.itemdata.startdate = this.formatDate(this.startdate);
    },
    enddate(val) {
      this.itemdata.enddate = this.formatDate(this.enddate);
    },
    internaldate(val) {
      this.itemdata.internaldate = this.formatDate(this.internaldate);
    },
    new_filling(val) {
      this.itemdata.new_filling = this.formatDate(this.new_filling);
    },
    last_annuity_paid(val) {
      this.itemdata.last_annuity_paid = this.formatDate(this.last_annuity_paid);
    },
    next_annuity_date(val) {
      this.itemdata.next_annuity_date = this.formatDate(this.next_annuity_date);
    },
    final_due_date_for_next_payment(val) {
      this.itemdata.final_due_date_for_next_payment = this.formatDate(
        this.final_due_date_for_next_payment
      );
    },
  },
};
